<header class="ion-header ion-hide-lg-up s">
  <header-main></header-main>
</header>

<main class="ion-content g" fullscreen>
  <header class="ion-hide-lg-down gr">
    <header-desktop></header-desktop>
    <h1>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ion-icon"><path d="M256 80a176 176 0 10176 176A176 176 0 00256 80z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"></path><path d="M200 202.29s.84-17.5 19.57-32.57C230.68 160.77 244 158.18 256 158c10.93-.14 20.69 1.67 26.53 4.45 10 4.76 29.47 16.38 29.47 41.09 0 26-17 37.81-36.37 50.8S251 281.43 251 296" fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="28"></path><circle cx="250" cy="348" r="20"></circle></svg>
      Contact
    </h1>
  </header>

  <div class="grid container">
    <div class="row">
      <div class="col col-xs-12 col-sm-8 col-lg-6 col-xl-4 col-sm-offset-1 col-lg-offset-3 col-xl-offset-4">
        <div class="ion-card ion-padding detail" *ngIf="!thanks">
          <ng-container *ngIf="auth.user | async as user; else guestcontact;">
            <div class="ion-card-content ion-padding">
              <div class="ion-card-title">Kia ora {{user.firstname}}!</div>
              <p>We want to ensure that your gigexchange experience is a good one.</p>
              <p>Our <a href="/support">help centre</a> is a great place to start, but if you can’t find your answer there please drop us a message.</p>
            </div>
            <form class="ion-padding" [formGroup]="form" (submit)="save()" novalidate autocomplete="off" (keyup.enter)="save()">
              <div class="ion-item">
                <div class="ion-label ion-padding-top" position="stacked"><strong>Name <sup>*</sup></strong></div>
                <input tappable #name type="text" placeholder="Your name" formControlName="name" [class.invalid]="!form.controls['name'].valid && form.controls['name'].dirty">
              </div>
              <div class="ion-item error-message ion-margin-bottom" *ngIf="(!form.controls['name'].valid && form.controls['name'].dirty)">
                <div class="ion-text ion-color-tertiary">
                  <small><sup>*</sup>Name needs more than 2 characters.</small>
                </div>
              </div>
              <div class="ion-item">
                <div class="ion-label ion-padding-top" position="stacked"><strong>Email <sup>*</sup></strong></div>
                <input tappable #email type="email" placeholder="Your email address" formControlName="email" [class.invalid]="!form.controls['email'].valid && form.controls['email'].dirty">
              </div>
              <div class="ion-item error-message ion-margin-bottom" *ngIf="(!form.controls['email'].valid && form.controls['email'].dirty)">
                <div class="ion-text ion-color-tertiary">
                  <small><sup>*</sup>Please enter a valid email.</small>
                </div>
              </div>
              <div class="ion-item">
                <div class="ion-label ion-padding-top" position="stacked"><strong>Message <sup>*</sup></strong></div>
                <textarea tappable #message type="message" placeholder="Your message" formControlName="message" [class.invalid]="!form.controls['message'].valid && form.controls['message'].dirty"></textarea>
              </div>
              <div class="ion-item error-message ion-margin-bottom" *ngIf="(!form.controls['message'].valid && form.controls['message'].dirty)">
                <div class="ion-text ion-color-tertiary">
                  <small><sup>*</sup>Please enter a valid message.</small>
                </div>
              </div>
              <button class="button button-round button-secondary ion-margin" [disabled]="!form.valid" (click)="save()">
                Send Message
              </button>
            </form>
          </ng-container>
          <ng-template #guestcontact>
            <div class="ion-card-content ion-padding">
              <div class="ion-card-title">Kia ora!</div>
              <p>We want to ensure that your gigexchange experience is a good one.</p>
              <p>Our <a routerLink="/support">help centre</a> is a great place to start, but if you can’t find your answer there please login then drop us a message.</p>
            </div>
            <a href="login">
              <button class="button button-round button-tertiary ion-margin">
                Login
              </button>
            </a>
          </ng-template>
        </div>
        <div class="ion-card ion-padding detail" *ngIf="thanks">
          <div class="ion-card-content ion-padding">
            <div class="ion-card-title">Thanks for your message!</div>
            <p>We'll get right back to you.</p>
            <p>Take a look at our <a href="/faqs">frequently asked questions</a>, you may find your answer there.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-footer ion-hide-lg-up">
  <footer-main></footer-main>
</footer>
